import { init, sendEvent } from "@dash0/sdk-web";

const manifest = require('../../../../deploy-manifest.json');

if (window.dash0Enabled) {
  init({
    serviceName: window.dash0ServiceName,
    environment: window.dash0Environment,
    serviceVersion: manifest.commit || 'dev',
    endpoint: {
      url: window.dash0Endpoint,
      authToken: window.dash0AuthToken,
      dataset: window.dash0Dataset,
    },
  });
}

export function trackBackofficeUiEvent(name, attributes = {}) {
  if (!window.dash0Enabled) {
    return;
  }

  sendEvent(name, { attributes });
}

window.trackBackofficeUiEvent = trackBackofficeUiEvent;
